import {ReactNode, useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";
import {usePageTracking} from "../../hooks/usePageTracking";
import {useAuth, useChat} from "../../context";
import {useSession} from "../../shared/session";

function PageTracker() {
    usePageTracking();
    return null;
}

// Rendered by <SessionProvider> only once the session is signed in (token
// verification, silent refresh, expiry and the sign-in redirect live there).
// What stays here is Resolve's own: the current user, page tracking.
function AppWrapper(props: {children?: ReactNode}) {
    const location = useLocation();
    const session = useSession();
    const auth = useAuth();
    const chat = useChat();
    // the user the current user was last fetched for: navigating and a
    // silent token refresh keep it, so the user (and everything keyed on it,
    // like the websocket) isn't fetched again.
    const fetchedFor = useRef<string>();
    const userKey = session.claims?.sub ?? session.token ?? "";
    useEffect(function () {
        if (auth.user) {
            chat.actions.setUser(auth.user);
        }
    }, [auth.user]);
    useEffect(function () {
        // a failed fetch is retried on the next navigation
        if (fetchedFor.current !== userKey || auth.status === "unauthenticated") {
            fetchedFor.current = userKey;
            auth.fetchUser();
        }
    }, [userKey, location]);
    return <>
        <PageTracker/>
        {props.children}
    </>;
}

export default AppWrapper;
